export class BaseService {
  //
}
